import mask from 'jquery-mask-plugin';

export default new class Form {
    constructor() {
        this.initMasks();
    }

    /**
     * Init jQuery masks
     */
    initMasks() {
        $('.js-tel').mask('+375 (00) 000-00-00', { placeholder: '+375 (29) 123 45 67' });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/form/form.js